import { useEffect, useState } from "react";
import { getCustomer } from "../../../shared/services/services";
import { CustomerData, CustomerTable } from "../../../shared/services/interface";

const useCustomer = (reFresh: boolean, filter?: boolean, page?: number, row?: number, searchTerm?: string, sortField?: string, order?: string) => {
  const [customer, setCustomer] = useState<CustomerTable>();
  const [onlyCustomer, setOnlyCustomer] = useState<CustomerData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchCustomers = () => {
    setLoading(true);
    getCustomer(filter, page, row, searchTerm, sortField, order)
      .then((res) => {
        const result = res?.data;
        setCustomer(result);
        setOnlyCustomer(result?.customer_details || []);
      })
      .catch((err) => {
        console.error("Error fetching customers:", err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchCustomers();
  }, [reFresh, filter, page, row, sortField, order]);

  useEffect(() => {
    if (searchTerm === undefined) return;
    const delay = setTimeout(fetchCustomers, 400);
    return () => clearTimeout(delay);
  }, [searchTerm]);

  return { customer, loading, onlyCustomer };
};

export default useCustomer;
